<script setup lang="ts">
import crystalBallIcon from "~/assets/icons/crystalball/crystalball-xs.svg"

defineProps({
  type: null,
  file: null,
  selected: { type: Boolean }
})
const { askAgentQuery } = useAgent()
const { state: instantState, closeInstantMenu } = useInstantMenu()

const askPolyAgent = () => {
  if (instantState.value.query.trim().length === 0)
    return console.warn("Cannot ask Poly Agent with an empty query")
  askAgentQuery(instantState.value.query)
  closeInstantMenu()
}
</script>

<template>
  <div
    v-if="type === 'ask-ai'"
    class="nav-instant-item ask-ai"
    @click="askPolyAgent()"
  >
    <div class="left">
      <crystal-ball-icon class="icon" />
      <div>Ask Poly Agent...</div>
    </div>
    <div class="right">
      <menu-shortcut>⇧↵</menu-shortcut>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.nav-instant-item
  @apply flex items-center gap-1.5 -m-1.5 p-1.5 rounded-[#{$menu-br-item}]
  @apply t-menu-sm text-[#{global-t-default}]
  @apply cursor-pointer
  &:hover, &.selected
    @apply bg-[#{$menu-bg-item-hover}]

.ask-ai
  @apply justify-between
  .left, .right
    @apply flex items-center gap-1.5
</style>
